import React from 'react';
import styled from 'styled-components';
import { tr } from '../translation';

const Container = styled.div`
  display: flex;
  flex: 1;
  min-width: 100%;
  min-height: 100vh;
  background: ${({ theme }) => theme.homeBackground};
`;

const BlurContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  border-radius: 16px;
  padding: 3rem;
`;

const LoadingText = styled.div`
  font-size: ${({ theme }) => theme.text.s8};
  background: linear-gradient(-90deg, #7a7a7a 0%, #ffffff 50%, #7a7a7a 100%);
  background-size: 200% auto;
  animation: shine 2s linear infinite;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 600;

  @keyframes shine {
    to {
      background-position: -200% center;
    }
  }
`;

const AppLoading = () => {
  return (
    <Container>
      <BlurContainer>
        <LoadingText>{tr('app.loading')}</LoadingText>
      </BlurContainer>
    </Container>
  );
};

export default AppLoading;
